import React from 'react';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import RequestPasswordReset from './RequestPasswordReset/RequestPasswordReset';
import PasswordReset from './PasswordReset/PasswordReset';
import ConfirmEmail from './ConfirmEmail/ConfirmEmail';

class Assist extends React.Component{

    render(){

        return (
            <div>
            <Helmet>
            <title>Assist | BookMeeY</title>
            <meta name="description" content="Assist you for email confirmation, password reset, and many more." />
            </Helmet>
            <Route path="/assist/request_password_reset" component={RequestPasswordReset}/>
            <Route path="/assist/reset_password/:uid/:token" component={PasswordReset}/>
            <Route path="/assist/confirm_email/:key" component={ConfirmEmail}/>
            </div>
        );
    }
}

export default Assist;


// WEBPACK FOOTER //
// ./src/containers/Assist/Assist.js